import { HSOverlay, ICollectionItem } from "preline";
import { initVideoPlayerSingle } from "../lib/feed-media-player";


export function VideoTutorialModal() {
    let $videoContainer: HTMLElement | null = null;
    let $modalElem: HTMLElement | null = null;

    function populate(videoUrl:string){
        $videoContainer = document!.getElementById("video-tutorial-container") as HTMLElement;
        $modalElem = document!.getElementById("video-tutorial-modal") as HTMLElement;
        $videoContainer!.innerHTML = `<video id="video-tutorial-player" class="w-full h-full object-cover absolute top-0 left-0 cursor-pointer bg-gray-200 rounded-lg" controlslist="nodownload noplaybackrate nofullscreen">
        <source src="${videoUrl}" type="video/mp4">
        Your browser does not support the video tag.
        </video>`;
        initVideoPlayerSingle($videoContainer!, false, true);
        const modalCloseBtns = $modalElem?.querySelectorAll('[data-hs-overlay="#video-tutorial-modal"]') as NodeListOf<HTMLElement>
        const videoPlayer = document.getElementById("video-tutorial-player") as HTMLVideoElement;

        modalCloseBtns.forEach(elem => {
            const el = HSOverlay.getInstance(elem, true) as ICollectionItem<HSOverlay>;
            el?.element?.on('close', () => {
                videoPlayer.pause();
            });
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                videoPlayer.pause();
            }
          });
    }
    

    function render() {
        return /*html*/`
        <div id="video-tutorial-modal" class="hs-overlay hidden size-full fixed top-0 start-0 z-[80] overflow-x-hidden overflow-y-auto pointer-events-none" role="dialog" tabindex="-1" aria-labelledby="hs-scale-animation-modal-label">
            <div class="hs-overlay-animation-target hs-overlay-open:scale-100 hs-overlay-open:opacity-100 scale-95 opacity-0 ease-in-out transition-all duration-200 sm:max-w-[calc(100%-30px)] sm:w-[960px] m-3 sm:mx-auto min-h-[calc(100%-3.5rem)] flex items-center">
            <div class="w-full flex flex-col bg-white border shadow-sm rounded-xl pointer-events-auto dark:bg-neutral-800 dark:border-neutral-700 dark:shadow-neutral-700/70">
                <div class="flex justify-between items-center py-3 px-4 border-b dark:border-neutral-700">
                <h3 id="hs-scale-animation-modal-label" class="font-bold text-gray-800 dark:text-white">
                    Know more about new version of Feedspace
                </h3>
                <button type="button" class="size-8 inline-flex justify-center items-center gap-x-2 rounded-full border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-700 dark:hover:bg-neutral-600 dark:text-neutral-400 dark:focus:bg-neutral-600" aria-label="Close" data-hs-overlay="#video-tutorial-modal">
                    <span class="sr-only">Close</span>
                    <svg class="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M18 6 6 18"></path>
                    <path d="m6 6 12 12"></path>
                    </svg>
                </button>
                </div>
                <div class="p-4 overflow-y-auto">
                <div id="video-tutorial-container" class="relative pt-[56.25%]">
                    <video id="video-tutorial-player" class="w-full h-full object-cover absolute top-0 left-0 cursor-pointer bg-gray-200 rounded-lg">
                    <source src="https://feedspace-test.s3.ap-south-1.amazonaws.com/uploads/LuJHRc/video-feed/feed_iYuVE5617214130610202.mp4" type="video/mp4">
                    Your browser does not support the video tag.
                    </video>
                </div>
                </div>
            </div>
            </div>
        </div>`;
    }
    return {
        render,
        populate
    }
}
